import { useEffect, useContext } from "react";
import { apiDomain, xs_product_code } from "../..";
import { appConfig } from "../../appConfig";
import { arePathnamesEqual, concatUrlPathnames, loadHTMLResource, setHTML } from "../sport-utils";
import { getConfiguration } from '../utils/configuration';
import { loadLanguage } from '../utils/loadLanguage';
import { loadSystemCode } from '../utils/loadSystemCode';
import { loadSystemCodeFromQueryString } from '../utils/loadSystemCodeFromQueryString';
import { SeoContext } from "./SeoContextProvider";
import { getEnv } from "../env";
import $ from 'jquery';
import { isLoadedInIframe } from "../utils/isLoadedInIframe";

const robotsTags = null;
const DUMMY_DOMAIN = 'https://www.domain.it';
export function fetchOriginalPath(path,isMobile){
    let base = (appConfig && appConfig.ROUTES && appConfig.ROUTES['prematch']) || '';
    if(base){
        base = isMobile?base['prematch']:base['top-match']
    }
    let fetchedPath = '';
    try {
        //const url = window.XSPORT_PUBLIC_URL+'/contenuti_seo/getOriginalFromSeoPath.json'
        //const url = 'http://localhost:8080/XSeo/xsport/getPath'
        const url = getConfiguration().api.getSeoRealPathName;
        const systemCode = loadSystemCode(apiDomain);
        const language = loadLanguage().toUpperCase();
        $.ajax({
            url : url,
            type : "GET",
            data : "systemCode="+systemCode+"&url=" + encodeURIComponent(path)+"&language=" +language ,
            async: false,
            success : (response) => {
                if(response){
                    fetchedPath = response === 'prematch'?base: concatUrlPathnames(base,response);

                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(thrownError);
              }
        });
    }catch(err) {
        console.log(err);
    }
    
    //handleCanonicalUrl(path);
    return fetchedPath/*  || path */;

}

export function fetchSeoConfig(setFechedState,isMobile) {
    const script = document.createElement('script');
    const systemCode = loadSystemCodeFromQueryString() || loadSystemCode(apiDomain);
    const language = loadLanguage().toUpperCase();
    //script.src = 'http://localhost:8083/XSeo/xsport/static-object-js/'+systemCode+'/'+xs_product_code+'/seo-config.js';
    
    try {
        script.src = `${getEnv('REACT_APP_API_DOMAIN') || appConfig.DOMAIN || ''}/XSeo/xsport/static-object-js/${systemCode}/${xs_product_code}/seo-config.js?ts=`+(Date.now());
        script.onload = function() {

            if(!window.seoConfig && window.seoConfigs && Object.keys(window.seoConfigs).length > 0){
                const mergedSeoConfigs = mergeSeoConfigs(window.seoConfigs['DEFAULT'][language],window.seoConfigs[systemCode] && window.seoConfigs[systemCode][language]);
                window.seoConfig = mergedSeoConfigs;
                window.seoConfigs = undefined;
            }
            /** per disabilitare il seo in automatico */
            if(window.seoConfig && getEnv('REACT_APP_DISABLE_SEO')){
            	window.seoConfig.enbsc[systemCode] = false;

            }
            if(window.seoConfig && window.seoConfig.enbsc && window.seoConfig.enbsc[systemCode] !== true){
                window.seoConfig = null;
                setFechedState(true);
                return ;
            }
            if (window.seoConfig && getConfiguration()) {
                getConfiguration().seo = window.seoConfig;
            }

            if(window.seoConfig && window.seoConfig.html){
                if(!isMobile && window.seoConfig.html){
                    window.seoConfig.html['top-match'] = window.seoConfig.html['prematch'];
                    window.seoConfig.html['live-suite'] = window.seoConfig.html['live']
                }
            }
            if(window.seoConfig && window.seoConfig.ump && appConfig){
                //appConfig.URL_PATH_MAPPINGS = {...appConfig.URL_PATH_MAPPINGS,...window.seoConfig.ump}
                let base = appConfig && appConfig.ROUTES && appConfig.ROUTES['prematch'];
                if(base){
                    base = isMobile?base['prematch']:base['top-match']
                }
                base && Object.entries(window.seoConfig.ump).forEach(function([k,v]){
                    if(!v.startsWith(base)){
                        window.seoConfig.ump[k] = base+v;
                    }
                })
                appConfig.URL_PATH_MAPPINGS = {...appConfig.URL_PATH_MAPPINGS,...window.seoConfig.ump}
                handleSeoConfigUrlMapping();
            }
            if(window.seoConfig && ((isMobile &&  window.seoConfig.rts_mobile) || (!isMobile &&  window.seoConfig.rts) ) && window.seoConfig.rts && appConfig){
                if(isMobile){
                    appConfig.ROUTES = {...appConfig.ROUTES,...window.seoConfig.rts_mobile}
                }else{
                    appConfig.ROUTES = {...appConfig.ROUTES,...window.seoConfig.rts}
                }
            }
            setFechedState(true);
        };
        script.onerror = function() {
            setFechedState(true);
        };
        document.head.append(script);
    }catch(err){
        setFechedState(true);
        console.log(err);
    }
}

export function isSeoUrlDisabled(systemCode){
    const conf = getConfiguration();
    let dsbsu;
  
    if((null || conf?.seo?.dsbsu?.[systemCode]) != null){
        dsbsu = conf?.seo?.dsbsu?.[systemCode];
    }else{
        dsbsu = conf?.seo?.dsbsu?.['DEFAULT'];
    }
    return dsbsu == true;
}


function handleSeoConfigUrlMapping(){
    const pathname = window.location.pathname.replace(appConfig.BASENAME,'');
    //console.log(pathname);
    if(appConfig.URL_PATH_MAPPINGS[pathname]){
        return;
    }
    if(window.seoConfig.ump){
        const parts = pathname.match(/\/[^/]+/mg);
        //console.log(parts)
        /*parts && parts.forEach(function(p){
            let v = window.seoConfig.ump[p];
            if(v){
                let suffix = v.match(/(_\d+){1,5}/mg);
                if(suffix.length > 0){
                    suffix = suffix[suffix.length-1];
                    v = v.replace(suffix,'');
                    if(!appConfig.URL_PATH_MAPPINGS[pathname]){
                        appConfig.URL_PATH_MAPPINGS[pathname] = pathname.replace(p,v);
                    }
                }
            }
        })*/
        if(parts){
            for(let i=parts.length;i>0;i--){
                let p = parts.slice(0,i).join('');
                let v = window.seoConfig.ump[p]; 
                if(v){
                    let suffix = v.match(/(_\d+){1,5}/mg);
                    if(suffix.length > 0){
                        suffix = suffix[suffix.length-1];
                        v = v.replace(suffix,'');
                        if(!appConfig.URL_PATH_MAPPINGS[pathname]){
                            appConfig.URL_PATH_MAPPINGS[pathname] = pathname.replace(p,v);
                        }
                    }
                }
            }
        }
    }
}





export function useHandleSeoSettings(seoSettingsState){
    const seoContext = useContext(SeoContext);
    useEffect(function() {
        if (seoContext != null) {
            if(seoSettingsState.isLoading){
                seoContext.setMetas(null);
                seoContext.setOpenGraphMetas(null);
                seoContext.setJsonLd(null);
                seoContext.setLabel(null);
                seoContext.setHtmlHref(null);
                seoContext.setHtmlContent(null);
            }
            else{
                seoContext.setMetas({});
                seoContext.setJsonLd({});
                seoContext.setLabel(undefined);
                seoContext.setHtmlHref(undefined);
                seoContext.setHtmlContent(undefined);
            }
        }
    }, [seoSettingsState.isLoading]);
    useEffect(function() {
           if(seoSettingsState.data && seoSettingsState.data.seo){
               if(seoSettingsState.data.seo.mtgs){
                seoContext.setMetas({'ti':seoSettingsState.data.seo.mtgs.ti,
                    'md':seoSettingsState.data.seo.mtgs.md,
                    'kwds':seoSettingsState.data.seo.mtgs.kwds,
                    'rbts':seoSettingsState.data.seo.mtgs.rbts,
                    'curl':seoSettingsState.data.seo.mtgs.curl,
                });
               }else{
                //seoContext.setMetas(undefined);
                seoContext.setMetas({});
               }

               if(seoSettingsState.data.seo.jsonld){
                seoContext.setJsonLd(seoSettingsState.data.seo.jsonld);
               }else{
                seoContext.setJsonLd({});
               }
               seoContext.setLabel(seoSettingsState.data.seo.label);
               seoContext.setOpenGraphMetas(seoSettingsState.data.seo.ogtgs);
               const hr = seoSettingsState.data.seo.fhurl || (seoContext.htmlHref === undefined?null:seoContext.htmlHref === null?undefined: seoSettingsState.data.seo.fhurl);
               const hc = seoSettingsState.data.seo.ihtml || (seoContext.htmlContent === undefined?null:seoContext.htmlContent === null?undefined: seoSettingsState.data.seo.ihtml);
               seoContext.setHtmlHref(hr);
               seoContext.setHtmlContent(hc);
           }else{
               if(!seoSettingsState.isLoading){
                    //seoContext.setMetas(undefined);
                    seoContext.setMetas({});
                    seoContext.setOpenGraphMetas(undefined);
                    seoContext.setJsonLd(undefined);
                    seoContext.setLabel(null);
                    seoContext.setHtmlHref(seoContext.htmlHref === undefined ? null : seoContext.htmlHref === null?undefined : seoContext.htmlHref);
                    seoContext.setHtmlContent(seoContext.htmlContent === undefined ? null : seoContext.htmlContent === null?undefined : seoContext.htmlContent);
               }
           
           }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seoSettingsState.data]);
}

export function useHandleSeoMetas(pathname,section,htmlContainerId){
    const changeMetaTags = isLoadedInIframe() ? appConfig?.HANDLERS?.['changeMetaTags']: undefined;
    let metaTagsChanged = {};
    const cfgSeo = getConfiguration().seo;
    const seoContext = useContext(SeoContext);
    useEffect(() => {
        try {
            if(seoContext.refreshMetas && !seoContext?.historyBackPressed) {
                if(seoContext.metas && Object.keys(seoContext.metas).length > 0){
                    const metas = {
                    'title':replacePlaceholders(seoContext.metas.ti),
                    'description': replacePlaceholders(seoContext.metas.md),
                    'keywords':seoContext.metas.kwds,
                    "rbts":JSON.parse(seoContext.metas.rbts || '{}')
                    }
                    handleMetaTags(metas);
                    handleOpenGraphMetaTags(seoContext.ogmetas);
                    handleCanonicalUrl(seoContext?.metas?.curl || window.location.pathname)
                    metaTagsChanged = {...metaTagsChanged,...metas}
                }else{
                    //if(seoContext.metas !== undefined){
                    if(seoContext.metas &&  Object.keys(seoContext.metas).length == 0){
                        handleSeoMetasForSection(cfgSeo,pathname,section,htmlContainerId);
                        handleCanonicalUrlForSection(cfgSeo,section,window.location.pathname);
                    }
                } 
    
                if(seoContext.jsonld && Object.keys(seoContext.jsonld).length > 0){
                    handleJsonLd(seoContext.jsonld);
                    metaTagsChanged = {...metaTagsChanged,...seoContext.jsonld}
                }else{
                    if(seoContext.jsonld && Object.keys(seoContext.jsonld).length == 0){
                        handleJsonLdForSection(cfgSeo,pathname,section,htmlContainerId);
        
                    }
                }
                if(Object.keys(metaTagsChanged).length > 0) {
                    changeMetaTags?.(metaTagsChanged);
                }
            }
        }catch(err){
            console.log(err);
        }
        //if(seoContext.metas){
    }, [seoContext.metas]);
    
}

export function useHandleSeoHtml(pathname,section,htmlContainerId){
    const cfgSeo = getConfiguration().seo;
    const seoContext = useContext(SeoContext);

    useEffect(() => {
        if(seoContext.htmlContent){
            seoContext.setShowHtmlContainer((seoContext.htmlContent || null) != null);
            setHTML(seoContext.htmlContent || null,htmlContainerId)
        }else if(seoContext.htmlHref){
            seoContext.setShowHtmlContainer((seoContext.htmlHref || null) != null);
            loadHTMLResource(seoContext.htmlHref || null, htmlContainerId);
        }else{
            handleSeoHtmlForSection(cfgSeo,pathname,section,htmlContainerId,seoContext);
        }
        
    }, [seoContext.htmlHref, seoContext.htmlContent/*, pathname,section */]);
    
}

function handleSeoMetasForSection(cfgSeo,pathname,section, htmlContainerId){
    const changeMetaTags = isLoadedInIframe() ? appConfig?.HANDLERS?.['changeMetaTags']: undefined;
    let metaTagsChanged = {};
    try {
        const seoSettings =  cfgSeo && cfgSeo.html && cfgSeo.html[section];
        //console.log(seoSettings)
        if(seoSettings){
            if(seoSettings.mtgs){
                const metas = {
                    'title':replacePlaceholders(seoSettings.mtgs.ti),
                    'description': replacePlaceholders(seoSettings.mtgs.md),
                    'keywords':seoSettings.mtgs.kwds,
                    "rbts":JSON.parse(seoSettings.mtgs.rbts || '{}')
                }
                metaTagsChanged = {...metaTagsChanged,...metas}
                handleMetaTags(metas);
            }
            
            if(seoSettings.ogtgs){
                handleOpenGraphMetaTags(seoSettings.ogtgs)
            }
            if(Object.keys(metaTagsChanged).length > 0) {
                changeMetaTags?.(metaTagsChanged);
            }
        }
    }catch(err){
        console.log(err);
    }
    
}

function handleJsonLdForSection(cfgSeo,pathname,section, htmlContainerId){
    const seoSettings =  cfgSeo && cfgSeo.html && cfgSeo.html[section];
    //console.log(seoSettings)
    if(seoSettings){
        if(seoSettings.jsonld){
            handleJsonLd(seoSettings.jsonld);
        }else{
            handleJsonLd(null);
        }
    }
}

function handleSeoHtmlForSection(cfgSeo,pathname,section, htmlContainerId,seoContext){
    const seoSettings = cfgSeo && cfgSeo.html && cfgSeo.html[section];
    let route = appConfig.ROUTES.routeFromPath(pathname);

    if(!route && appConfig.URL_PATH_MAPPINGS && Object.keys( appConfig.URL_PATH_MAPPINGS).length > 0){
        route = appConfig.ROUTES.routeFromPath(appConfig.URL_PATH_MAPPINGS[pathname])
    }

    if(!route) {
        route = appConfig.ROUTES.routeFromPath(pathname?.replace(appConfig.BASENAME,""));
    }

    const sectionPathname = route?appConfig.ROUTES[route][section]:section;
    if(seoSettings){
        //const setContent = (pathname || '').endsWith(sectionPathname);
        //const setContent = window.location.pathname == concatUrlPathnames(appConfig.BASENAME,sectionPathname);
        const setContent = arePathnamesEqual(window.location.pathname,concatUrlPathnames(appConfig.BASENAME,sectionPathname));
        const hasContent = seoSettings.ihtml || seoSettings.fhurl;
        seoContext.setShowHtmlContainer(setContent && hasContent);
        if(seoSettings.ihtml){
            setHTML(setContent?(seoSettings.ihtml || null):null,htmlContainerId);
        }else{
            loadHTMLResource(setContent?(seoSettings.fhurl || null):null,htmlContainerId);
        }
    }
}

export function handleMetaTags(metas){
    const head = document.getElementsByTagName("head")[0];
    let title = document.getElementsByTagName("TITLE")[0];

    if(!title && head) {
        title = document.createElement('title');
        head.appendChild(title);
    }

    if(title && metas['title']){
        title.innerHTML = metas['title'];
    }

    if(title){
        if(metas['keywords']){
            let metakeywords = document.querySelectorAll("meta[name='keywords']")[0];
            if(!metakeywords){
                metakeywords = document.createElement("meta");
                metakeywords.setAttribute("name","keywords");
                title.insertAdjacentElement('afterEnd',metakeywords)
            }
            metakeywords.setAttribute("content", metas['keywords']);
        }

        if(metas['description']){
            let metadescription = document.querySelectorAll("meta[name='description']")[0];
            if(!metadescription){
                metadescription = document.createElement("meta");
                metadescription.setAttribute("name","description");
                title.insertAdjacentElement('afterEnd',metadescription)
            }
            metadescription.setAttribute("content", metas['description']);
        }
    }

    if(metas['rbts']){
        Object.keys(metas['rbts']).forEach(function(k){
            let rbtTag = document.querySelectorAll("meta[name='"+k+"']")[0];
            if(!rbtTag){
                rbtTag = document.createElement("meta");
                rbtTag.setAttribute("name",k);
                rbtTag.setAttribute("content",metas['rbts'][k]);
                if(title){
                    title.insertAdjacentElement('afterEnd',rbtTag)
                }else{
                    head.appendChild(rbtTag);
                }
            }
        })
    }
}

export function handleOpenGraphMetaTags(ogmetas){
    const title = document.getElementsByTagName("TITLE")[0];

    let ogtgs = document.querySelectorAll("meta[data-ogtgs]");
    ogtgs && ogtgs.forEach(function(o){
        o.remove();
    })

    if(title){
        if(ogmetas){
            Object.entries(ogmetas).forEach(([key, value]) =>{
                key = new RegExp('[a-zA-Z]:', 'i').test(key)?key:"og:"+key;
                let ogmeta = document.querySelectorAll("meta[property='"+key+"']")[0];
                if(!ogmeta){
                    ogmeta = document.createElement("meta");
                    ogmeta.setAttribute("property",key);
                    ogmeta.setAttribute("data-ogtgs","");
                    title.insertAdjacentElement('afterEnd',ogmeta)
                }
                ogmeta.setAttribute("content", value);
            });
        }
    }
}

export function handleJsonLd(jsonld){
    const head = document.getElementsByTagName("head")[0];

    try{
        //document.querySelectorAll("script[type='application/ld+json'][id^='xsp_']").forEach(e => e.remove());
        if((jsonld || null) == null || Object.keys(jsonld).length == 0){
            return;
        }

        Object.keys(jsonld).forEach(function(k){
            const id = k?.startsWith('xsp_')?k:'xsp_'+k;
            let jsonldTag =  document.querySelector("script[type='application/ld+json'][id='"+id+"']");
            if(!jsonldTag){
                jsonldTag = document.createElement("script");
                jsonldTag.setAttribute("type","application/ld+json");
                jsonldTag.setAttribute("id",id);
            }
            
            jsonldTag.innerHTML = jsonld[k]?.replaceAll(DUMMY_DOMAIN,window.origin);
            head.appendChild(jsonldTag);
        })
    }catch(err){
        console.log(err);
    }
}

export function handleCanonicalUrlForSection(cfgSeo,section,defaultUrl){
    let canonicalUrl = defaultUrl;
    try {
        const seoSettings =  cfgSeo && cfgSeo.html && cfgSeo.html[section];
        canonicalUrl = seoSettings?.mtgs?.curl || defaultUrl;
    }catch(err){
        console.log(err);
    }
    handleCanonicalUrl(canonicalUrl);
}

export function handleCanonicalUrl(url){
    if(!getConfiguration().seo || !url){
        return;
    }else{
        if(!url.startsWith(window.location.origin)){
           if(appConfig && appConfig.BASENAME && !url.startsWith(appConfig.BASENAME)){
                url = concatUrlPathnames(appConfig.BASENAME,url);
           }
            url = window.location.origin+url;
        }
    }
    let canonical = document.querySelector("link[rel='canonical']");
    const head = document.getElementsByTagName("head")[0];

    if(!canonical){
        canonical = document.createElement("link");
        canonical.setAttribute("rel","canonical");
        canonical.setAttribute("href",url)
        head.appendChild(canonical);
        canonical.setAttribute("href",url);
    }
}

export let isSeoSettingsNoFollow = function(seoSettings) {
    const noFollow = getConfiguration().seo ? seoSettings?.nf ?? false : false;

    isSeoSettingsNoFollow = noFollow ? () => true : () => false;

    return isSeoSettingsNoFollow();
}

function replacePlaceholders(value){
    let toReturn = value;
    try {
        if(toReturn){
            const placeHolders = {
                'sitename':{'pholder':'{sitename}','lkey':'xseo.site_name'},
                'concgad':{'pholder':'{concgad}','lkey':'xseo.conc_gad'}
            }
           
            Object.values(placeHolders).forEach(function(p){
                let label = getSeoSettingsLabel(p.lkey,loadSystemCodeFromQueryString() || loadSystemCode(apiDomain),loadLanguage().toUpperCase());
                if(label){
                    toReturn = toReturn.replaceAll(p.pholder,label);
                }
            });

           
        }
    }catch(err){
        console.log(err);
    }
  
    return toReturn;
}

function getSeoSettingsLabel(labelKey,systemCode,language){
    let label = null;

    try {
        const cfgSeo = getConfiguration().seo;
        if(cfgSeo && cfgSeo.lbls){
            const labelsByProductCode = cfgSeo.lbls[xs_product_code] || cfgSeo.lbls[3]; //3 is the product code for desktop
            if(labelsByProductCode && labelsByProductCode['labels']){
                const labelsBySysCode = labelsByProductCode['labels'][systemCode] || labelsByProductCode['labels']['DEFAULT'];
                if(labelsBySysCode){
                    const labelsByLang = labelsBySysCode[language];
                    label =  labelsByLang && labelsByLang[labelKey];
                }
            }
            
        }
    }catch(err){
        console.log(err)
    }

    return label;
    
}

export function mergeSeoConfigs(conf1,conf2){
   var merged = conf1 && {...conf1};
   var html = merged && merged['html'];
   var html2 = conf2 && conf2['html'];
   html && Object.keys(html).forEach(function(h){
       //Merging metatags
       mergeFields(html && html[h],html2 && html2[h],'mtgs');
       /*var mtgs =  html[h] && html[h]['mtgs'];
       var mtgs2 =  html2 &&  html2[h] && html2[h]['mtgs'];
       mtgs && Object.keys(mtgs).forEach(function(m){
            if(mtgs2 && mtgs2[m]){
                mtgs[m] = mtgs2[m];
            }
       })*/
       //Merging open graph tags
       var ogtgs = html[h] && html[h]['ogtgs'];
       var ogtgs2 =  html2 &&  html2[h] && html2[h]['ogtgs'];
       ogtgs && Object.keys(ogtgs).forEach(function(o){
            if(ogtgs2 && ogtgs2[o]){
                ogtgs[o] = ogtgs2[o];
            }
       }) 
       //Merging inner HTML
       var ihtml2 = html2 && html2[h] && html2[h]['ihtml'];
       if(ihtml2 && html && html[h] ){
             html[h]['ihtml'] = ihtml2;
       }
       //Merging href URL
       var fhurl2 = html2 && html2[h] && html2[h]['fhurl'];
       if(fhurl2 && html && html[h] ){
             html[h]['fhurl'] = fhurl2;
       }
       //Merging JSON-LD
       mergeFields(html && html[h],html2 && html2[h],'jsonld')
       //Merging label
        var label2 = html2 && html2[h] && html2[h]['label'];
        if(label2 && html && html[h] ){
                html[h]['label'] = label2;
        }
   })
  //Merging routes
   var rts = merged && merged['rts'];
   var rts2 = conf2 && conf2['rts'];
  
   rts && Object.keys(rts).forEach(function(r){
       var sec = rts[r];
       var sec2 = rts2 && rts2[r];
       sec && Object.keys(sec).forEach(function(s){
           if(sec2 && sec2[s]){
            sec[s] = sec2[s];
           }
       });
   });
   //Merging mobile routes
   var rts_mobile = merged && merged['rts_mobile'];
   var rts_mobile2 = conf2 && conf2['rts_mobile'];

   rts_mobile && Object.keys(rts_mobile).forEach(function(r){
       var sec = rts_mobile[r];
       var sec2 = rts_mobile2 && rts_mobile2[r];
       sec && Object.keys(sec).forEach(function(s){
           if(sec2 && sec2[s]){
            sec[s] = sec2[s];
           }
       });
   });

   if(merged && merged['html'] &&  Object.values(merged['html'])){
       return merged;
   }else{
        return conf2;
   }   
}

function mergeFields(obj1,obj2,fieldName){
    var field1 = obj1 && obj1[fieldName];
    var field2 =  obj2 && obj2[fieldName];
    if(field1){
         Object.keys(field1).forEach(function(o){
             if(field2 && field2[o]){
                field1[o] = field2[o];
             }
         }) 
    } 
    if(field2){
         field1  = field1 || {};
         Object.keys(field2).forEach(function(o){
            if(field2[o]){
                field1[o] = field2[o];
             }
         }) 
         obj1[fieldName] = field1;
    }
}

export function buildEventURL(desc) {
    function replacer(match, separator, spaces, forwardSlash, offset, string, groups) {
        if (separator !== undefined) {
            return 'vs';
        }
        if (spaces !== undefined || forwardSlash !== undefined) {
            return '-';
        }
    }
    return desc.replace(/(?<separator>-)|(?<spaces>\s+)|(?<forward_slash>\/)/g, replacer);
}
